import React from 'react';
import { useSortBy } from '@apgnext/frontend/legacy/js/components/molecules/filter/useSortBy';

import { ReactComponent as IconChevronUp } from '@srcDS/icons/tailwind-icons/icon-cheveron-up.svg';
import { ReactComponent as IconChevronDown } from '@srcDS/icons/tailwind-icons/icon-cheveron-down.svg';

import styles from '../Toolbar.module.scss';

interface SortTitleProps {
  sortShown: boolean;
  activeFilter: any;
  sortState?: { attributeId: string; order: string; } | null;
  toggleSortModal: (event: React.MouseEvent) => void;
}

const findByValue = (array, targetValue)=> {
  return array.find(item =>
    JSON.stringify(item.value) === JSON.stringify(targetValue)
  );
}

const SortTitle = ({ sortShown, activeFilter, toggleSortModal, sortState }: SortTitleProps) => {
  const { sortValues } = useSortBy();
  const isSortSelected = findByValue(sortValues, sortState);

  return (
    <div className={styles.sortTitle} onClick={(e) => toggleSortModal(e)}>
      {isSortSelected
        ? (<>Sort By: <span className={styles.selectedSort}>{isSortSelected && isSortSelected.name}</span></>)
        : 'Sort'
      }
      {sortShown && !activeFilter ? (
        <IconChevronUp className={styles.arrowIcon} />
      ) : (
        <IconChevronDown className={styles.arrowIcon} />
      )}
    </div>
  );
};

export default SortTitle;
